import { Component, HostListener, Input, OnInit } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Organization } from "../../model/organization";
import { LocalStorageService } from "../../services/local-storage";
import { OrganizationService } from "../../services/organization.service";

@Component({
    selector: 'app-print-checks',
    template: `
    <ng-container *ngIf="selectedStyles">
        <ion-item>
            <ion-label>Font Size</ion-label>
            <ion-input type="number" step=".1" [(ngModel)]="selectedStyles.fontSize"></ion-input>
        </ion-item>
        <ion-item style="text-align: center;">
            <ion-icon style="font-size: 16px; padding: 2px; border: 1px solid grey;" (click)="arrowLeft()" name="arrow-back"></ion-icon>      
            <ion-icon style="font-size: 16px; padding: 2px; border: 1px solid grey;" (click)="arrowRight()" name="arrow-forward"></ion-icon>  
            <ion-icon style="font-size: 16px; padding: 2px; border: 1px solid grey;" (click)="arrowUp()" name="arrow-up"></ion-icon>  
            <ion-icon style="font-size: 16px; padding: 2px; border: 1px solid grey;" (click)="arrowDown()" name="arrow-down"></ion-icon>  
        </ion-item>
    </ng-container>

    <ng-container *ngIf="selectedFormat">
        <ion-title>Save Format</ion-title>
        <ion-item>
            <ion-label>Name</ion-label>
            <ion-input [(ngModel)]="selectedFormat.displayName"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Organization</ion-label>
            <ion-select [(ngModel)]="selectedFormat.organizationId">
            <ion-option *ngFor="let org of userOrganizations" [value]="org.id">{{org.name}}</ion-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label>Is Private</ion-label>
            <ion-toggle color="secondary" [(ngModel)]="isPrivateFormat" (ionChange)="updateAccountId($event)"></ion-toggle>
        </ion-item>
        <button ion-button (click)="close()">Save</button>
    </ng-container>
`
})
export class CheckStylePopover implements OnInit {
    @Input() selectedStyles: any;
    @Input() selectedFormat: any;
    userOrganizations: Organization[] = [];
    isPrivateFormat: boolean = false;
    currentUserId: number;

    @HostListener('window:keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
      if (this.selectedStyles) {
        switch(event.key) {
          case 'ArrowDown':
            event.preventDefault();
            this.arrowDown();
            break;
          case 'ArrowUp':
            event.preventDefault();
            this.arrowUp();
            break;
          case 'ArrowRight':
            event.preventDefault();
            this.arrowRight();
            break;
          case 'ArrowLeft':
            event.preventDefault();
            this.arrowLeft();
            break;
        }
      }
    }

    constructor(public viewCtrl: ViewController, private storageService: LocalStorageService, private organizationService: OrganizationService, private params: NavParams) { }

    ngOnInit(): void {
        this.selectedStyles = this.params.get('selectedStyles');
        this.selectedFormat = this.params.get('selectedFormat');

        if (this.selectedFormat && this.selectedFormat.accountId && this.selectedFormat.accountId > 0) {
            this.isPrivateFormat = true;
        }

        this.storageService.getEntity('authtokens')
            .then((token: any) => {
                const isAdmin = token.roles.map(x => x.roleId).includes(6);
                const orgIds = token.roles.map(x => x.organizationId) as number[];
                this.currentUserId = token.id;
                this.organizationService.getOrganizations()
                .then((orgs: Organization[]) => {
                  this.userOrganizations = isAdmin ? orgs : orgs.filter(x => orgIds.includes(x.id));
                });
          
            });
    }

    updateAccountId(event: any) {
        const isPrivate = event.value;

        if (isPrivate) {
            this.selectedFormat.accountId = this.currentUserId;
        } else {
            this.selectedFormat.accountId = 0;
        }
    }

    close() {
        if (this.selectedFormat) {
            this.viewCtrl.dismiss(this.selectedFormat);
        } else {
            this.viewCtrl.dismiss();
        }
    }

    arrowLeft() {
        if (this.selectedStyles.right != null) {
            this.selectedStyles.right += 1;
        } else {
            this.selectedStyles.left -= 1;
        }
    }

    arrowRight() {
        if (this.selectedStyles.right != null) {
            this.selectedStyles.right -= 1;
        } else {
            this.selectedStyles.left += 1;
        }
    }

    arrowUp() {
        if (this.selectedStyles.bottom != null) {
            this.selectedStyles.bottom += 1;
        } else {
            this.selectedStyles.top -= 1;
        }
    }

    arrowDown() {
        if (this.selectedStyles.bottom != null) {
            this.selectedStyles.bottom -= 1;
        } else if (this.selectedStyles.top) {
            this.selectedStyles.top += 1;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/print-checks/check-style-popover.component.ts